import * as Joi from 'joi'

function isValidEmail(emailString: string) {
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+(com|br|net|org|gov|edu)))$/
  return reg.test(emailString)
}

export const loginSchema = Joi.object({
  login: Joi.string()
    .required()
    .custom((value, helpers) => {
      if (!value) return value

      if (!isValidEmail(value)) {
        return helpers.error('any.invalid')
      }

      return value
    })
    .messages({
      'any.invalid': 'Um email segue o formato: nome@domínio.com',
      'string.empty': 'O E-mail precisa ser preenchido',
    }),
  password: Joi.string().required().messages({
    'string.empty': 'A Senha precisa ser preenchida',
  }),
})
